import React, { useState, useEffect } from "react";
import ReportsAssetTable from "./components/ReportsAssetTable";
import ReportsPartnerTable from "./components/ReportsPartnerTable";
import ReportsEmployeeTable from "./components/ReportsEmployeeTable";
import ReportsCampaignTable from "./components/ReportsCampaignTable";
import { Pie } from "react-chartjs-2";
import Divider from "@material-ui/core/Divider";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Badge } from "react-bootstrap";
import Tooltip from "@material-ui/core/Tooltip";
import { RiFileExcel2Fill } from "react-icons/ri";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

export default function Reports() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortField, setSortField] = useState("id");
  const [orderBy, setOrderBy] = useState(false);
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);

  const onReports1 = (toggleState) => {
    setIsLoaded(true);
    toggleState === 1 &&
      axios
        .get(`${process.env.REACT_APP_API_URL}report/asset`, {
          headers: {
            "Accept-Language": 1,
          },
        })
        .then(
          ({ data: { assets } }) => {
            setIsLoaded(false);
            setRows(assets);
          },

          (error) => {
            setIsLoaded(false);
            setError(true);
            setRows([]);
            setCount(0);
          }
        );
    // console.log(toggleState);
  };

  const onReports2 = (toggleState) => {
    setIsLoaded(true);
    toggleState === 2 &&
      axios
        .get(`${process.env.REACT_APP_API_URL}report/partner`, {
          headers: {
            "Accept-Language": 1,
          },
        })
        .then(
          ({ data: { partners } }) => {
            setIsLoaded(false);
            setRows(partners);
          }
          ).catch((error) => {
            setIsLoaded(false);
            setError(true);
            setRows([]);
            setCount(0);
          });
    // console.log(toggleState);
  };

  const onReports3 = (toggleState) => {
    setIsLoaded(true);
    toggleState === 3 &&
      axios
        .get(`${process.env.REACT_APP_API_URL}report/campaign`, {
          headers: {
            "Accept-Language": 1,
          },
        })
        .then(
          ({ data: { campaigns } }) => {
            setIsLoaded(false);
            setRows(campaigns);
          },

          (error) => {
            setIsLoaded(false);
            setError(true);
            setRows([]);
            setCount(0);
          }
        );
    // console.log(toggleState);
  };

  const onReports4 = (toggleState) => {
    setIsLoaded(true);

    toggleState === 4 &&
      axios
        .get(`${process.env.REACT_APP_API_URL}report/employee`, {
          headers: {
            "Accept-Language": 1,
          },
        })
        .then(
          ({ data: { employees } }) => {
            setIsLoaded(false);
            setRows(employees);
          },

          (error) => {
            setIsLoaded(false);
            setError(true);
            setRows([]);
            setCount(0);
          }
        );
    // console.log(toggleState);
  };

  const [chartData, setChartData] = useState({});
  const [chartData2, setChartData2] = useState({});
  const [chartData3, setChartData3] = useState({});
  const [chartData4, setChartData4] = useState({});
  const [totalAssetCount, setTotalAssetCount] = useState([]);
  const [totalPartnerCount, setTotalPartnerCount] = useState([]);
  const [totalCampaignCount, setTotalCampaignCount] = useState([]);
  const [totalEmployeeCount, setTotalEmployeeCount] = useState([]);

  const chart1 = (toggleState) => {
    let empChart1 = [];
    toggleState === 1 &&
      axios.get(`${process.env.REACT_APP_API_URL}report/asset`).then((res) => {
        const dataObj2 = res.data;
        empChart1.push(dataObj2.activeAssetCount);
        empChart1.push(dataObj2.deactiveAssetCount);
        empChart1.push(dataObj2.deletedAssetCount);
        empChart1.push(dataObj2.totalAssetCount);
        setTotalAssetCount(empChart1);
        setChartData({
          labels: ["Active", "Deactive", "Deleted"],
          datasets: [
            {
              data: [
                dataObj2.activeAssetCount,
                dataObj2.deactiveAssetCount,
                dataObj2.deletedAssetCount,
              ],
              backgroundColor: ["#fa9500", "#babd8d", "#eb6424"],
              hoverOffset: 4,
            },
          ],
        });
      });
  };

  const chart2 = (toggleState) => {
    let empChart2 = [];
    toggleState === 2 &&
      axios
        .get(`${process.env.REACT_APP_API_URL}report/partner`)
        .then((res) => {
          const dataObj = res.data;
          empChart2.push(dataObj.activePartnerCount);
          empChart2.push(dataObj.deactivePartnerCount);
          empChart2.push(dataObj.deletedPartnerCount);
          empChart2.push(dataObj.totalPartnerCount);
          setTotalPartnerCount(empChart2);

          setChartData2({
            labels: ["Active", "Deactive", "Deleted"],
            datasets: [
              {
                // label: "level of thiccness",
                data: [
                  dataObj.activePartnerCount,
                  dataObj.deactivePartnerCount,
                  dataObj.deletedPartnerCount,
                ],
                backgroundColor: [
                  "rgb(54,255,25 )",
                  "rgb(27,197,255)",
                  "rgb(167,197,189)",
                ],
                hoverOffset: 4,
              },
            ],
          });
        });
  };

  const chart3 = (toggleState) => {
    let empChart3 = [];
    toggleState === 3 &&
      axios
        .get(`${process.env.REACT_APP_API_URL}report/campaign`)
        .then((res) => {
          const dataObj3 = res.data;
          empChart3.push(dataObj3.activeCampaignCount);
          empChart3.push(dataObj3.deactiveCampaignCount);
          empChart3.push(dataObj3.deletedCampaignCount);
          empChart3.push(dataObj3.totalCampaignCount);
          setTotalCampaignCount(empChart3);

          setChartData3({
            labels: ["Active", "Deactive", "Deleted"],
            datasets: [
              {
                data: [
                  dataObj3.activeCampaignCount,
                  dataObj3.deactiveCampaignCount,
                  dataObj3.deletedCampaignCount,
                ],
                backgroundColor: ["#2a1177", "#DDC9FF", "#6d52f4"],
                hoverOffset: 4,
              },
            ],
          });
        });
  };

  const chart4 = (toggleState) => {
    let empChart4 = [];
    toggleState === 4 &&
      axios
        .get(`${process.env.REACT_APP_API_URL}report/employee`)
        .then((res) => {
          const dataObj4 = res.data;
          empChart4.push(dataObj4.activeEmployeeCount);
          empChart4.push(dataObj4.deactiveEmployeeCount);
          empChart4.push(dataObj4.deletedEmployeeCount);
          empChart4.push(dataObj4.totalEmployeeCount);
          setTotalEmployeeCount(empChart4);

          setChartData4({
            labels: ["Active", "Deactive", "Deleted"],
            datasets: [
              {
                data: [
                  dataObj4.activeEmployeeCount,
                  dataObj4.deactiveEmployeeCount,
                  dataObj4.deletedEmployeeCount,
                ],
                backgroundColor: ["#072ac8", "#cfe57d", "#ffcb17"],
                hoverOffset: 4,
              },
            ],
          });
        });
  };

  useEffect(() => {
    onReports1(toggleState);
    onReports2(toggleState);
    onReports3(toggleState);
    onReports4(toggleState);
    chart1(toggleState);
    chart2(toggleState);
    chart3(toggleState);
    chart4(toggleState);
  }, [toggleState]);


  const onReportsExportTwo = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}report/export/counts`, {
        responseType: "blob",
      })
      .then((res) => {
        var url2 = window.URL.createObjectURL(new Blob([res.data]));
        var a2 = document.createElement("a");
        a2.href = url2;
        a2.download = "Reports-count.xlsx";
        document.body.appendChild(a2);
        a2.click();
        a2.remove();
      });
  };

  const onReportsExport = () => {
        axios.get(`${process.env.REACT_APP_API_URL}report/export`, {
          responseType: "blob",
        })
      .then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "Reports-name.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      })

  };



  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center justify-content-between py-4">
        <h1 className="display-4 mb-0">Reports</h1>
        <div>
          <Tooltip title="Export" placement="top">
            <button
              aria-label="Add balance"
              className="flex-shrink-0 btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2 h5 rounded-circle flex-shrink-0"
              onClick={() => { onReportsExport(); onReportsExportTwo();}}
            >
              <RiFileExcel2Fill />
            </button>
          </Tooltip>
          
        </div>
      </div>
      <Paper className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab
            label="Asset"
            className={toggleState === 1 ? "tabs active-tabs" : "tabs"}
            onClick={() => onReports1(toggleTab(1), chart1(toggleTab(1)))}
          />
          <Tab
            label="Partner"
            className={toggleState === 2 ? "tabs active-tabs" : "tabs"}
            onClick={() => onReports2(toggleTab(2), chart2(toggleTab(2)))}
          />
          <Tab
            label="Campaign"
            className={toggleState === 3 ? "tabs active-tabs" : "tabs"}
            onClick={() => onReports3(toggleTab(3), chart3(toggleTab(3)))}
          />
          <Tab
            label="Employee"
            className={toggleState === 4 ? "tabs active-tabs" : "tabs"}
            onClick={() => onReports4(toggleTab(4), chart4(toggleTab(4)))}
          />
        </Tabs>
      </Paper>

      <Divider className="w-100" />

      <div
        className={toggleState === 1 ? "content  active-content" : "content"}
      >
        <div className="d-flex">
          <ReportsAssetTable
            setSortField={setSortField}
            setOrderByTable={setOrderBy}
            sortField={sortField}
            orderBy={orderBy}
            isLoaded={isLoaded}
            error={error}
            rows={rows}
            count={count}
            setToggleState={setToggleState}
            toggleState={toggleState}
            onReports={() => onReports1(toggleState === 1)}
          />
          <div className=" my-5 " style={{ width: "300px" }}>
            <Badge
              className="reportsBadge"
              style={{
                backgroundColor: "#7c6a0a",
                padding: "15px",
                color: "#fff",
                fontSize: "14px",
                marginBottom: "20px",
              }}
            >
              Total Asset Count: {totalAssetCount[3]}
            </Badge>
            <Pie data={chartData} options={{ responsive: true }} />
          </div>
        </div>
      </div>

      <div
        className={toggleState === 2 ? "content  active-content" : "content"}
      >
        <div className="d-flex">
          <ReportsPartnerTable
            setSortField={setSortField}
            setOrderByTable={setOrderBy}
            sortField={sortField}
            orderBy={orderBy}
            isLoaded={isLoaded}
            error={error}
            rows={rows}
            count={count}
            setToggleState={setToggleState}
            toggleState={toggleState}
            onReports={() => onReports2(toggleState === 2)}
            onReportsExportTwo={onReportsExportTwo}
            onReportsExport={onReportsExport}
          />
          <div className=" my-5 chartSizes" style={{ width: "300px" }}>
            <Badge
              className="reportsBadge"
              style={{
                backgroundColor: "#054a29",
                padding: "15px",
                color: "#fff",
                fontSize: "14px",
                marginBottom: "20px",
              }}
            >
              Total Partner Count: {totalPartnerCount[3]}
            </Badge>
            <Pie data={chartData2} options={{ responsive: true }} />
          </div>
        </div>
      </div>

      <div
        className={toggleState === 3 ? "content  active-content" : "content"}
      >
        <div className="d-flex">
          <ReportsCampaignTable
            setSortField={setSortField}
            setOrderByTable={setOrderBy}
            sortField={sortField}
            orderBy={orderBy}
            isLoaded={isLoaded}
            error={error}
            rows={rows}
            setToggleState={setToggleState}
            toggleState={toggleState}
            onReports={() => onReports3(toggleState === 3)}
          />
          <div className=" my-5  chartSizes" style={{ width: "300px" }}>
            <Badge
              className="reportsBadge"
              style={{
                backgroundColor: "#b388eb",
                padding: "15px",
                color: "#fff",
                fontSize: "14px",
                marginBottom: "20px",
              }}
            >
              Total Campaign Count: {totalCampaignCount[3]}
            </Badge>
            <Pie data={chartData3} options={{ responsive: true }} />
          </div>
        </div>
      </div>

      <div
        className={toggleState === 4 ? "content  active-content" : "content"}
      >
        <div className="d-flex">
          <ReportsEmployeeTable
            setSortField={setSortField}
            setOrderByTable={setOrderBy}
            sortField={sortField}
            orderBy={orderBy}
            isLoaded={isLoaded}
            error={error}
            rows={rows}
            setToggleState={setToggleState}
            toggleState={toggleState}
            onReports={() => onReports4(toggleState === 4)}
          />
          <div className=" my-5 chartSizes " style={{ width: "300px" }}>
            <Badge
              className="reportsBadge"
              style={{
                backgroundColor: "#004e98",
                padding: "15px",
                color: "#fff",
                fontSize: "14px",
                marginBottom: "20px",
              }}
            >
              Total Employee Count: {totalEmployeeCount[3]}
            </Badge>
            <Pie data={chartData4} options={{ responsive: true }} />
          </div>
        </div>
      </div>
    </div>
  );
}